import { createDialog } from '../../util/createDialog';

const dialog = createDialog();

/** @type {DialogFactory<{theme?: 'light' | 'dark'}>} */
export const $$infoDialog = {
  ...dialog
};
